module.exports = __webpack_public_path__ + "img/jcb.9ca6d600.png";